import React from 'react';

import {pluralize} from 'BenchlingUtil';

export interface RowCountTextProps {
  numRows?: number;
  hide?: boolean;
}

export function RowCountText({numRows, hide}: RowCountTextProps): JSX.Element | null {
  if (numRows == null || hide) {
    return null;
  }
  const formattedText = `${numRows} ${pluralize(numRows, 'row')}`;
  return <span className="u-faded u-mini-spacing-left">{formattedText}</span>;
}
